import camelCase from './camelCase';
class Router {
    constructor(routes) {
        this.routes = routes;
        this.routes = routes;
    }
    fire(route, event = 'init', arg = null) {
        document.dispatchEvent(new CustomEvent('routed', {
            bubbles: true,
            detail: {
                route,
                fn: event,
            },
        }));
        const fire = route !== '' &&
            this.routes[route] &&
            typeof this.routes[route][event] === 'function';
        if (fire) {
            this.routes[route][event](arg);
        }
    }
    loadEvents() {
        this.fire('common');
        const currentRoutes = document.body.dataset.route
            .toLowerCase()
            .replace(/-/g, '_')
            .split(/\s+/)
            .map(camelCase);
        currentRoutes.forEach((route) => {
            this.fire(route);
        });
        currentRoutes.forEach((route) => {
            this.fire(route, 'finalize');
        });
        this.fire('common', 'finalize');
    }
}
export default Router;
